/* eslint-disable lint/a11y/noStaticElementInteractions */

const _gettext = window.gettext

export const Buttons = (props) => {
  const checkDisplayCondition = () => {
    return !(
      props.display_condition &&
      ((!props.form.summaryActive &&
        props.display_condition === "summary-active") ||
        (props.form.summaryActive &&
          props.display_condition === "summary-inactive"))
    )
  }

  return (
    checkDisplayCondition() && (
      <div class={`buttons ${props.class || ""}`}>
        {props.buttons.map((buttonProps, i) => {
          return (
            <Button
              {...buttonProps}
              form={props.form}
              key={`${props.form.stepId}-${i}`}
            />
          )
        })}
      </div>
    )
  )
}

export const Button = (props) => {
  const disabled = () => {
    if (props.type === "next") {
      return !props.form.requirementsMet()
    }
    if (props.type === "submit" && props.function === "sendAnonymously") {
      return [{ name: "reporter_gender" }, { name: "reporter_role" }].some(
        (c) => props.form.inFormValues(c),
      )
    }
    if (typeof props.disabled !== "undefined") {
      return props.disabled
    }
    return false
  }

  const customFunctions = (e) => {
    e.preventDefault()

    if (props.onClick) props.onClick()
    else {
      switch (props.type) {
        case "submit":
          props.form.onSubmit()
          break
        case "link":
          document.location = props.href
          break
        case "external-link":
          window.open(props.href, "_blank")
          break
        case "close":
          // modal specific
          props.form.setModalData({})
          break
        default:
          // next step
          props.form.showStep(0, props.id)
      }
    }
  }

  return (
    <button
      class={`button ${props.class || ""}`}
      type={props.type}
      onClick={customFunctions}
      disabled={disabled()}
    >
      {props.label}
      {/*disabled() && (
        <div
          class="requirements-help"
          onClick={props.form?.showHelp}
          onKeyUp={props.form?.showHelp}
        >
          <div>{gettext("Weitere Angaben erforderlich")}</div>
        </div>
      )*/}
    </button>
  )
}
